import {
  CustomFormPageFieldUuidToSettingsMap,
  CustomFormPageFieldUuidToValueMap
} from '@flicent/fieldpulse-react-component-library-frontend';

import { ApiServiceInstance } from './Api.service';


interface RequestParams {
  token: string;
  fillTemplateCustomFormId: number;
}

interface ResponseDataType {
  page_field_uuid_to_value_map: CustomFormPageFieldUuidToValueMap;
  page_field_uuid_to_settings_map: CustomFormPageFieldUuidToSettingsMap;
}

export const getFillTemplateCustomFormRequest = ({
                                                   token,
                                                   fillTemplateCustomFormId
                                                 }: RequestParams): Promise<ResponseDataType> => {
  return ApiServiceInstance.makeRequest(`/custom-form/fill-template/${ fillTemplateCustomFormId }`, {
    token,
  });
};